'use client';
import cx from 'classnames';
import { useTranslations } from 'next-intl';
import {
  CatBadge,
  CatIconTagFilled,
  CatTextPassage,
  CatTooltip
} from 'components/blocks-components';
import { useBreakpoint, Conditional } from '@cat-ecom/pcc-components';
import { PAGE_BREAKPOINTS } from 'constants/common';
import styles from './promo-badge.module.scss';

interface PromoSpecialsBadgeProps {
  className?: string;
  promos?: Specials;
  isProductOverview?: boolean;
}

const PromoBadge = ({
  className,
  promos = {},
  isProductOverview = false
}: PromoSpecialsBadgeProps) => {
  const t = useTranslations();
  const isMD = useBreakpoint(PAGE_BREAKPOINTS.MD);
  const { name = t('PROMO_OFFER'), description } = promos;
  const isTruncated = description?.length > 35;
  const truncatedDescription = isTruncated
    ? description.slice(0, 35) + '...'
    : description;
  return (
    <CatBadge
      variant="grey"
      className={cx(styles['promos-badge'], className, {
        [styles['promos-badge__extra-margin']]: isProductOverview
      })}
    >
      <div slot="before" className="d-flex">
        <div className="d-flex">
          <CatIconTagFilled slot="before" className="align-content-center" />
          <div className="d-inline-grid">
            <span className="ps-2">{name}</span>
            {isProductOverview && description && (
              <span className={`ps-2 cat-u-theme-typography-footnote`}>
                {truncatedDescription}
              </span>
            )}
          </div>
        </div>
        <Conditional test={isTruncated && isProductOverview}>
          <CatTooltip
            position="top"
            className="align-content-center"
            isInteractive={!isMD}
          >
            <span
              slot="trigger"
              className="ms-2 text-decoration-underline text-primary"
            >
              {t('PROMOTIONS_DESCRIPTION_DETAILS')}
            </span>
            <CatTextPassage size="sm">{description}</CatTextPassage>
          </CatTooltip>
        </Conditional>
      </div>
    </CatBadge>
  );
};

export default PromoBadge;
